import Field, { InputFieldProps } from "./Field";

export interface PhoneFieldProps extends Omit<InputFieldProps, "controlType"> {}

export default function PhoneField(props: PhoneFieldProps) {
  return <Field controlType="input" prefix="+91" type="tel" {...props} />;
}
